import groq from 'groq';
import { DOCUMENT } from '@pkg/config/sanity/schemas';

export const blockLocationFinderFields = groq`
  ...,
  "staticTranslations": *[
      _type == "${DOCUMENT.FRAGMENT_SURPRISE_BAG}" && language == $locale][0],
`;